<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="select_result_pop">
    <RadioGroup v-model="operateStyle">
      <Radio label="0">
        <span>按选中结果</span>
      </Radio>
      <Radio label="1">
        <span>按搜索结果</span>
      </Radio>
    </RadioGroup>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="onOk()">确认</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
        name: "DeleteTitlePop",
        props: {
          publicTitle:String,
          showTitlePop:Boolean,
        },
        data(){
          return {
            title:'删除提示',
            model:false,
            operateStyle:'0',
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeTitlePop",false);
          },
          onOk:function () {
            this.$emit("closeTitlePop",true,this.operateStyle);
          }
        },
        watch:{
          showTitlePop:function () {
            this.model=this.showTitlePop;
            if(this.publicTitle){
              this.title=this.publicTitle;
              this.operateStyle = '0';
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerMange/DeleteTitlePop.vue